import {
    IDataArray
} from "./../../shared/index"

export class SurveyDocument implements IDataArray {
    public Pkid = 0;
    public FileName: string;
    public MetadataId: number;
    public ReplacedById: number;
    public UploadDate: Date;

    public GetById(): number {
        return this.Pkid;
    }
}